import { useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import {
  LayoutDashboard,
  UserCheck,
  Users,
  Bike,
  ShoppingBag,
  UtensilsCrossed,
  CreditCard,
  Wallet,
  BarChart3,
  Megaphone,
  Settings,
  ShieldCheck,
  Headset,
  TicketPercent,
  Landmark,
  ChevronRight,
  LogOut,
  X,
} from "lucide-react";

import "./AdminMenu.css";

/* ======================================================
   MENU DATA
====================================================== */

const menuItems = [
  {
    title: "Dashboard",
    icon: <LayoutDashboard size={20} />,
    path: "/admin/dashboard",
  },

   {
    title: "Providers",
    icon: <UserCheck size={20} />,
    path: "/admin/providers",
  },

  {
    title: "Customers",
    icon: <Users size={20} />,
    path: "/admin/customers",
  },

  {
    title: "Delivery Partners",
    icon: <Bike size={20} />,
    path: "/admin/delivery",
  },

  {
    title: "Foods",
    icon: <UtensilsCrossed size={20} />,
    path: "/admin/foods",
  },

  {
    title: "Orders",
    icon: <ShoppingBag size={20} />,
     path: "/admin/orders",
  },

  {
    title: "Payments",
    icon: <CreditCard size={20} />,
    children: [
      {
        title: "Transactions",
        path: "/admin/payments",
      },
      {
        title: "Settlements",
        path: "/admin/settlements",
      },
      {
        title: "Wallet",
        path: "/admin/earnings",
      },
    ],
  },

  {
    title: "Marketing",
    icon: <Megaphone size={20} />,
    children: [
      {
        title: "Campaigns",
        path: "/admin/marketing",
      },
      {
        title: "Coupons",
        path: "/admin/coupons",
      },
      {
        title: "Notifications",
        path: "/admin/notifications",
      },
    ],
  },

  {
    title: "Reports",
    icon: <BarChart3 size={20} />,
    path: "/admin/reports",
  },

  {
    title: "Support",
    icon: <Headset size={20} />,
    path: "/admin/support",
  },

  {
    title: "Settings",
    icon: <Settings size={20} />,
    children: [
      {
        title: "Roles",
        path: "/admin/roles",
      },
      {
        title: "Admin Users",
        path: "/admin/admin-users",
      },
      {
        title: "General Settings",
        path: "/admin/settings",
      },
    ],
  },
];

/* ======================================================
   COMPONENT
====================================================== */

function AdminMenu({
  open,
  setOpen,
}) {
  const navigate = useNavigate();

  const [expandedMenu, setExpandedMenu] =
    useState(null);

  /* ==========================================
      LOGOUT
  ========================================== */

  const handleLogout = () => {
    const confirmLogout = window.confirm(
      "Are you sure you want to logout?"
    );

    if (!confirmLogout) return;

    localStorage.removeItem("token");
    localStorage.removeItem("user");

    navigate("/admin/login", {
      replace: true,
    });
  };

  /* ==========================================
      TOGGLE MENU
  ========================================== */

  const toggleMenu = (menu) => {
    if (expandedMenu === menu) {
      setExpandedMenu(null);
    } else {
      setExpandedMenu(menu);
    }
  };

  return (
    <>
      {/* Overlay */}

      {open && (
        <div
          className="menu-overlay"
          onClick={() => setOpen(false)}
        />
      )}

      {/* Drawer */}

      <aside
        className={`admin-menu ${
          open ? "open" : ""
        }`}
      >
        {/* Header */}

        <div className="menu-header">
          <div className="menu-logo">
            <img
              src="/images/logo.png"
              alt="HomeFoods"
            />

            <div>
              <h2>HomeFoods</h2>
              <span>Admin Portal</span>
            </div>
          </div>

          <button
            className="menu-close"
            onClick={() => setOpen(false)}
          >
            <X size={22} />
          </button>
        </div>

        {/* Menu List */}

       {/* ======================================================
    MENU LIST
====================================================== */}

<div className="menu-list">

  {menuItems.map((menu) => (

    <div
      className="menu-item"
      key={menu.title}
    >

      {/* ===============================
          SIMPLE MENU
      =============================== */}

      {!menu.children && (

        <NavLink
          to={menu.path}
          end
          onClick={() => setOpen(false)}
          className={({ isActive }) =>
            isActive
              ? "menu-link active"
              : "menu-link"
          }
        >

          <div className="menu-icon">

            {menu.icon}

          </div>

          <span>

            {menu.title}

          </span>

        </NavLink>

      )}

      {/* ===============================
          ACCORDION MENU
      =============================== */}

      {menu.children && (

        <>

          <button
            className={`menu-link accordion-btn ${
              expandedMenu === menu.title
                ? "expanded"
                : ""
            }`}
            onClick={() =>
              toggleMenu(menu.title)
            }
          >

            <div className="menu-left">

              <div className="menu-icon">

                {menu.icon}

              </div>

              <span>

                {menu.title}

              </span>

            </div>

            <ChevronRight
              size={18}
              className={`accordion-arrow ${
                expandedMenu === menu.title
                  ? "rotate"
                  : ""
              }`}
            />

          </button>

          {/* ===============================
              SUB MENU
          =============================== */}

          {expandedMenu === menu.title && (

            <div className="submenu">

              {menu.children.map((child) => (

                <NavLink
                  key={child.title}
                  to={child.path}
                  onClick={() => setOpen(false)}
                  className={({ isActive }) =>
                    isActive
                      ? "submenu-link active"
                      : "submenu-link"
                  }
                >

                  <span className="submenu-dot" />

                  <span>

                    {child.title}

                  </span>

                </NavLink>

              ))}

            </div>

          )}

        </>

      )}

    </div>

  ))}

</div>

        {/* Footer */}

       {/* ======================================================
    FOOTER
====================================================== */}

<div className="menu-footer">

  {/* Admin Profile */}

  <div className="menu-admin">

    <div className="admin-avatar">

      <ShieldCheck size={24} />

    </div>

    <div className="admin-details">

      <h4>

        HomeFoods Admin

      </h4>

      <p>

        Super Administrator

      </p>

    </div>

  </div>

  {/* Logout */}

  <button
    className="logout-btn"
    onClick={handleLogout}
  >

    <LogOut size={20} />

    <span>

      Logout

    </span>

  </button>

</div>

      </aside>
    </>
  );
}

export default AdminMenu;